var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { create } from 'zustand';
export var useProviderStore = create(function (set) { return ({
    state: {
        currentProvider: undefined,
        isAvailableMultiprovider: false,
    },
    actions: {
        setCurrentProvider: function (provider) {
            set(function (_a) {
                var state = _a.state;
                return ({
                    state: __assign(__assign({}, state), { currentProvider: provider }),
                });
            });
        },
        setIsAvailableMultiprovider: function (isAvailableMultiprovider) {
            set(function (_a) {
                var state = _a.state;
                return ({
                    state: __assign(__assign({}, state), { isAvailableMultiprovider: isAvailableMultiprovider }),
                });
            });
        },
    },
}); });
